import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { CampaignBuilderDashboard } from "./campaign-builder-dashboard";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
    mutations: {
      retry: 0,
    },
  },
});

export function CampaignBuilderDashboardApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#ffffff",
            boxShadow:
              "0 4px 6px -1px rgb(71 85 105 / 0.1), 0 2px 4px -2px rgb(71 85 105 / 0.1)",
          },
          success: {
            duration: 3000,
            style: {
              color: "#10b981",
            },
            iconTheme: {
              primary: "#10b981",
              secondary: "#ffffff",
            },
          },
          error: {
            duration: 4000,
            style: {
              color: "#ef4444",
            },
            iconTheme: {
              primary: "#ef4444",
              secondary: "#ffffff",
            },
          },
        }}
      />
      <CampaignBuilderDashboard />
    </QueryClientProvider>
  );
}
